import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useCustomerAuth } from '@/contexts/CustomerAuthContext';

interface CustomerProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

export function CustomerProtectedRoute({
  children,
  redirectTo = '/customer/login',
}: CustomerProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useCustomerAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          Loading customer portal...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

